(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function initChristmasMenu() {
  document.querySelectorAll('.pl-christmas-menu').forEach(menu => {
    if (menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    const details = menu.querySelector('details');
    menu.addEventListener('pointerleave', () => {
      if (!menu.contains(document.activeElement)) details.open = false;
    });
    menu.addEventListener('focusout', event => {
      if (!menu.contains(event.relatedTarget)) details.open = false;
    });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
  });
}
initChristmasMenu();
document.addEventListener('shopify:section:load', initChristmasMenu);
  } catch(e) { console.error(e); }
})();

})();
